<template>
  <div class="para mt-0" style="width: 100%">
    <p class="lead mt-0">ログインセキュリティの設定を行います。</p>
    <h2 class="h3">ログインセキュリティ情報</h2>
    <!-- ******************************************************************
      *  ログインセキュリティ情報                                          *
    ****************************************************************** -->
    <div class="criteria">
      <div class="frm-row divide-border m-0 p-5">
        <span class="frm-label w-160px">
          <strong
            >パスワード誤りによる
            <br />
            アカウントロック</strong
          >
        </span>
        <ToggleButton
          ref="refPasswordToggle"
          v-model="accountLockInputErrorFlag"
          :list="radioList"
        />
        <BackupSelect
          :disabled="accountLockInputErrorFlag === 0"
          v-model="loginSecurityParams.accountLockInputErrorCount"
          :disabledSelectedItem="{ code: 0, text: '' }"
          defaultIndex="2"
          :itemList="
            accountLockInputErrorCountList.map((e) => {
              return { code: e, text: e };
            })
          "
        />
        <span :class="accountLockInputErrorFlag === 0 ? 'grey-text' : ''"
          >回連続で不正なパスワードを入力するとアカウントをロックする</span
        >
      </div>
      <div class="frm-row divide-border p-5 m-0">
        <span class="frm-label w-160px">
          <strong>パスワードの有効期限</strong>
        </span>
        <ToggleButton :list="radioList" v-model="passwordExpiryMonthFlag" />
        <BackupSelect
          :disabled="passwordExpiryMonthFlag === 0"
          v-model="loginSecurityParams.passwordExpiryMonth"
          :disabledSelectedItem="{ code: 0, text: '' }"
          :itemList="
            passwordExpiryMonthList.map((e) => {
              return { code: e, text: e };
            })
          "
        />
        <span :class="passwordExpiryMonthFlag === 0 ? 'grey-text' : ''"
          >カ月経過するとパスワード変更を要求する</span
        >
      </div>
      <div class="frm-row divide-border p-5 m-0">
        <span class="frm-label w-160px">
          <strong>パスワードの再利用制限</strong>
        </span>

        <ToggleButton v-model="passwordHistoryCountFlag" :list="radioList" />

        <BackupSelect
          :disabled="passwordHistoryCountFlag === 0"
          v-model="loginSecurityParams.passwordHistoryCount"
          defaultIndex="1"
          :disabledSelectedItem="{ code: 1, text: '' }"
          :itemList="
            passwordHistoryCountList.map((e) => {
              return { code: e, text: e };
            })
          "
        />
        <span :class="passwordHistoryCountFlag === 0 ? 'grey-text' : ''"
          >回別のパスワードを使用したのちに再利用を可能とする</span
        >
      </div>
      <div class="frm-row p-5 m-0 align-items-start">
        <span class="frm-label w-160px">
          <strong>通知設定</strong>
        </span>

        <div class="ml-3">
          <div>
            <div class="frm-row">
              <ToggleButton
                v-model="loginSecurityParams.newDeviceNotification"
                :list="radioList"
              />
              <span
                class="ml-5"
                :class="
                  loginSecurityParams.newDeviceNotification === 0
                    ? 'grey-text'
                    : ''
                "
                >各ユーザが初めて使用するデバイスでログインした場合に以下のユーザに通知する</span
              >
            </div>
            <p
              class="errMsg"
              v-show="errorList.some((e) => e.key === 'newDeviceNotification')"
            >
              <ErrorMessageCase
                :errors="
                  errorList.find((e) => e.key === 'newDeviceNotification') ?? []
                "
              ></ErrorMessageCase>
            </p>
            <div class="mt-5">
              <SingleCheckBox
                text="管理者"
                v-model="loginSecurityParams.newDeviceNotificationAdmin"
                :disabled="loginSecurityParams.newDeviceNotification === 0"
              />
            </div>
            <div class="mt-5">
              <SingleCheckBox
                text="ユーザ本人"
                v-model="loginSecurityParams.newDeviceNotificationTheUser"
                :disabled="loginSecurityParams.newDeviceNotification === 0"
              />
            </div>
            <div class="frm-row mt-5 error-group">
              <SingleCheckBox
                text="その他①"
                v-model="others1Flag"
                :disabled="loginSecurityParams.newDeviceNotification === 0"
              />
              <span class="frm-label">
                <span
                  :class="
                    !others1Flag ||
                    loginSecurityParams.newDeviceNotification === 0
                      ? 'grey-text'
                      : ''
                  "
                  >メールアドレス：</span
                >
              </span>
              <div class="input-with-error-area">
                <BackupInput
                  v-model="loginSecurityParams.newDeviceNotificationEmail1"
                  maxlength="255"
                  :disabled="
                    !others1Flag ||
                    loginSecurityParams.newDeviceNotification === 0
                  "
                  :hasError="
                    errorList.some(
                      (e) => e.key === 'newDeviceNotificationEmail1'
                    )
                  "
                />
                <p
                  class="errMsg"
                  v-show="
                    errorList.some(
                      (e) => e.key === 'newDeviceNotificationEmail1'
                    )
                  "
                >
                  <ErrorMessageCase
                    :errors="
                      errorList.find(
                        (e) => e.key === 'newDeviceNotificationEmail1'
                      ) ?? []
                    "
                  ></ErrorMessageCase>
                </p>
              </div>
            </div>
            <div class="frm-row mt-5 error-group">
              <SingleCheckBox
                class="w-150px"
                text="その他②"
                v-model="others2Flag"
                :disabled="loginSecurityParams.newDeviceNotification === 0"
              />
              <span class="frm-label">
                <span
                  :class="
                    !others2Flag ||
                    loginSecurityParams.newDeviceNotification === 0
                      ? 'grey-text'
                      : ''
                  "
                  >メールアドレス：</span
                >
              </span>
              <div class="input-with-error-area">
                <BackupInput
                  v-model="loginSecurityParams.newDeviceNotificationEmail2"
                  maxlength="255"
                  :disabled="
                    !others2Flag ||
                    loginSecurityParams.newDeviceNotification === 0
                  "
                  :hasError="
                    errorList.some(
                      (e) => e.key === 'newDeviceNotificationEmail2'
                    )
                  "
                />
                <p
                  class="errMsg"
                  v-show="
                    errorList.some(
                      (e) => e.key === 'newDeviceNotificationEmail2'
                    )
                  "
                >
                  <ErrorMessageCase
                    :errors="
                      errorList.find(
                        (e) => e.key === 'newDeviceNotificationEmail2'
                      ) ?? []
                    "
                  ></ErrorMessageCase>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <!-- ******************************************************************
           *  下部ボタン群                                                  *
           ****************************************************************** -->
    <div class="frm-btn-row footer-btn">
      <div class="frm-item grow center">
        <button
          class="frm-btn strong large"
          type="button"
          data-role="popup-open"
          data-target="#popup-confirm"
          @click="confirm"
        >
          確定
        </button>
      </div>
    </div>
    <ProcessingCompleteModal></ProcessingCompleteModal>
    <ConfirmDialog
      :isShow="showConfirmDialog"
      :message="message"
      @confirm="dialogConfirm"
      @cancel="dialogCancel"
    ></ConfirmDialog>
  </div>
</template>
<script setup>
import { ref, reactive, onMounted, watch, nextTick, unref } from "vue";
import { isEqual } from "lodash";
import { useStore } from "vuex";
import Validation from "@/util/validation.js";
import ErrorMessageCase from "@/components/ErrorMessageCase.vue";
import ToggleButton from "@/components/ToggleButton.vue";
import SingleCheckBox from "@/components/SingleCheckBox.vue";
import BackupInput from "@/components/BackupInput.vue";
import BackupSelect from "@/components/BackupSelect.vue";
import ProcessingCompleteModal from "@/components/STDSDC01C04ProcessingCompleteModal.vue";
import Common from "@/util/common.js";
import { useRouter, onBeforeRouteLeave } from "vue-router";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import {
  API_DisplayLoginSecurity,
  API_LoginSecurityChange,
} from "@/api/Modules/DC05/STDSDC05C07";
const { push } = useRouter();
//　アカウントロック list
const radioList = [
  { code: 0, text: "設定しない" },
  { code: 1, text: "設定する" },
];
//　アカウントロック list
const accountLockInputErrorCountList = [3, 4, 5, 6, 7, 8, 9];
// アカウントロック活性制御
const accountLockInputErrorFlag = ref(0);
//　パスワードの有効期限 list
const passwordExpiryMonthList = [1, 3, 6];
// パスワードの有効期限活性制御
const passwordExpiryMonthFlag = ref(0);
//　パスワードの再利用制限 list
const passwordHistoryCountList = [2, 3, 4, 5, 6, 7, 8, 9];
// パスワードの再利用制限活性制御
const passwordHistoryCountFlag = ref(0);
// その他１ 活性制御
const others1Flag = ref(false);
// その他2 活性制御
const others2Flag = ref(false);

const loginSecurityParams = reactive({
  // Webサイトからのサインイン制限有無
  restrictSigninByWeb: false,
  //　アカウントロック
  accountLockInputErrorCount: 0,
  // パスワードの有効期限
  passwordExpiryMonth: 0,
  // パスワードの再利用制限
  passwordHistoryCount: 1,
  // 通知設定
  newDeviceNotification: 0,
  // 管理者
  newDeviceNotificationAdmin: false,
  // ユーザー本人
  newDeviceNotificationTheUser: false,
  // その他１ mail
  newDeviceNotificationEmail1: "",
  // その他２ mail
  newDeviceNotificationEmail2: "",
});

const message = ref(Common.getMessage("MTCL2001", []));

// エラー
const errorList = ref([]);
// エラーチェック
const checkBeforeRequest = () => {
  errorList.value = [];
  // 通知設定が「設定する」の場合、チェックボックスが1つ以上選択されていること。
  if (
    loginSecurityParams.newDeviceNotification === 1 &&
    !loginSecurityParams.newDeviceNotificationAdmin &&
    !loginSecurityParams.newDeviceNotificationTheUser &&
    !others1Flag.value &&
    !others2Flag.value
  ) {
    errorList.value.push({
      key: "newDeviceNotification",
      error: Common.createError(
        "MTCL1032",
        Common.getMessage("MTCL1032", ["通知設定"])
      ),
    });
  }
  // メール必須入力チェック
  if (others1Flag.value && !loginSecurityParams.newDeviceNotificationEmail1) {
    errorList.value.push({
      key: "newDeviceNotificationEmail1",
      error: Common.createError("MTCL1122", Common.getMessage("MTCL1122")),
    });
  }
  // メール形式チェック
  else if (
    others1Flag.value &&
    loginSecurityParams.newDeviceNotificationEmail1 &&
    !Validation.isMail(loginSecurityParams.newDeviceNotificationEmail1)
  ) {
    errorList.value.push({
      key: "newDeviceNotificationEmail1",
      error: Common.createError(
        "MTCL1015",
        Common.getMessage("MTCL1015", ["メールアドレス"])
      ),
    });
  }
  // メール必須入力チェック
  if (others2Flag.value && !loginSecurityParams.newDeviceNotificationEmail2) {
    errorList.value.push({
      key: "newDeviceNotificationEmail2",
      error: Common.createError("MTCL1122", Common.getMessage("MTCL1122")),
    });
  }
  // メール形式チェック
  else if (
    others2Flag.value &&
    loginSecurityParams.newDeviceNotificationEmail2 &&
    !Validation.isMail(loginSecurityParams.newDeviceNotificationEmail2)
  ) {
    errorList.value.push({
      key: "newDeviceNotificationEmail2",
      error: Common.createError(
        "MTCL1015",
        Common.getMessage("MTCL1015", ["メールアドレス"])
      ),
    });
  }
};
// 親画面エラー表示制御
const { commit } = useStore();
watch(errorList, (val) => {
  const topError =
    val?.length > 0
      ? [Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))]
      : [];
  // vuex にコミット
  commit("securityModule/updateErrors", topError);
});
let passwordExpiryMonthBackup = 0;

let backupData;
// ログインセキュリティ登録
const changeLoginSecurity = () => {
  commit("businessModule/processDialogue", true);
  // ログインセキュリティ登録
  let params = Object.assign({}, unref(loginSecurityParams));
  params.newDeviceNotification =
    params.newDeviceNotification == 1 ? true : false;
  params.restrictSigninByWeb =
    loginSecurityParams.restrictSigninByWeb == 1 ? true : false;
  return API_LoginSecurityChange({ tzafdcSigninPolicy: params }).then(() => {
    passwordExpiryMonthBackup = passwordExpiryMonthFlag.value;

    backupData = params;

    commit("businessModule/processDialogue", false);

    commit("businessModule/completeDialogue", true);
  });
};
// 確定ブタン押下処理
const confirm = () => {
  checkBeforeRequest();
  if (errorList.value.length === 0) {
    // パスワードの有効期限が「設定しない」→「設定する」に変更となっている場合
    if (
      passwordExpiryMonthBackup === 0 &&
      passwordExpiryMonthFlag.value === 1
    ) {
      message.value = Common.getMessage("MTCL2098", []);
      showConfirmDialog.value = true;
    } else {
      changeLoginSecurity();
    }
  }
};

const refPasswordToggle = ref(null);
onMounted(async () => {
  // 初期位置設定
  nextTick(() => {
    refPasswordToggle.value.focus();
  });
  // 初期データ backup
  const result = await API_DisplayLoginSecurity();
  backupData = result?.tzafdcSigninPolicy;
  if (
    ![null, undefined, ""].includes(
      result.tzafdcSigninPolicy.accountLockInputErrorCount
    ) &&
    result.tzafdcSigninPolicy.accountLockInputErrorCount !== 0
  ) {
    accountLockInputErrorFlag.value = 1;
    nextTick(() => {
      loginSecurityParams.accountLockInputErrorCount =
        result.tzafdcSigninPolicy.accountLockInputErrorCount;
    });
  }
  if (
    ![null, undefined, ""].includes(
      result.tzafdcSigninPolicy.passwordExpiryMonth
    ) &&
    result.tzafdcSigninPolicy.passwordExpiryMonth !== 0
  ) {
    passwordExpiryMonthFlag.value = 1;
    passwordExpiryMonthBackup = passwordExpiryMonthFlag.value;
    nextTick(() => {
      loginSecurityParams.passwordExpiryMonth =
        result.tzafdcSigninPolicy.passwordExpiryMonth;
    });
  }
  if (
    ![null, undefined, ""].includes(
      result.tzafdcSigninPolicy.passwordHistoryCount
    ) &&
    result.tzafdcSigninPolicy.passwordHistoryCount !== 1
  ) {
    passwordHistoryCountFlag.value = 1;
    nextTick(() => {
      loginSecurityParams.passwordHistoryCount =
        result.tzafdcSigninPolicy.passwordHistoryCount;
    });
  }
  if (
    ![null, undefined, ""].includes(
      result.tzafdcSigninPolicy.newDeviceNotificationEmail1
    )
  ) {
    loginSecurityParams.newDeviceNotification = 1;
    nextTick(() => {
      others1Flag.value = true;
      nextTick(() => {
        loginSecurityParams.newDeviceNotificationEmail1 =
          result.tzafdcSigninPolicy.newDeviceNotificationEmail1;
      });
    });
  }
  if (
    ![null, undefined, ""].includes(
      result.tzafdcSigninPolicy.newDeviceNotificationEmail2
    )
  ) {
    loginSecurityParams.newDeviceNotification = 1;
    nextTick(() => {
      others2Flag.value = true;
      nextTick(() => {
        loginSecurityParams.newDeviceNotificationEmail2 =
          result.tzafdcSigninPolicy.newDeviceNotificationEmail2;
      });
    });
  }
  if (result.tzafdcSigninPolicy.newDeviceNotificationAdmin) {
    loginSecurityParams.newDeviceNotification = 1;
    nextTick(() => {
      loginSecurityParams.newDeviceNotificationAdmin =
        result.tzafdcSigninPolicy.newDeviceNotificationAdmin;
    });
  }
  if (result.tzafdcSigninPolicy.newDeviceNotificationTheUser) {
    loginSecurityParams.newDeviceNotification = 1;
    nextTick(() => {
      loginSecurityParams.newDeviceNotificationTheUser =
        result.tzafdcSigninPolicy.newDeviceNotificationTheUser;
    });
  }
  loginSecurityParams.newDeviceNotification =
    result.tzafdcSigninPolicy.newDeviceNotification === true ? 1 : 0;
  loginSecurityParams.restrictSigninByWeb = result.tzafdcSigninPolicy
    .restrictSigninByWeb
    ? 1
    : 0;
});

const showConfirmDialog = ref(false);
let targetRoute = "";
// onBeforeRouteLeave
onBeforeRouteLeave((to, from, next) => {
  // 画面遷移チェック
  if (!$cookies.get("SessionID") || to.name == "STDSCM04C06" || targetRoute) {
    next();
  } else {
    let params = Object.assign({}, unref(loginSecurityParams));
    backupData.restrictSigninByWeb = backupData.restrictSigninByWeb ? 1 : 0;
    backupData.accountLockInputErrorCount =
      backupData.accountLockInputErrorCount ?? 0;
    backupData.passwordExpiryMonth = backupData.passwordExpiryMonth ?? 0;
    backupData.passwordHistoryCount = backupData.passwordHistoryCount ?? 1;
    params.newDeviceNotification =
      params.newDeviceNotification == 1 ? true : false;
    backupData.newDeviceNotificationAdmin =
      backupData.newDeviceNotificationAdmin ?? false;
    backupData.newDeviceNotificationTheUser =
      backupData.newDeviceNotificationTheUser ?? false;
    backupData.newDeviceNotificationEmail1 =
      backupData.newDeviceNotificationEmail1 ?? "";
    backupData.newDeviceNotificationEmail2 =
      backupData.newDeviceNotificationEmail2 ?? "";
    if (!isEqual(params, backupData)) {
      targetRoute = to;
      message.value = Common.getMessage("MTCL2001", []);
      showConfirmDialog.value = true;
      return;
    }
    next();
  }
});
const dialogConfirm = async () => {
  switch (message.value) {
    case Common.getMessage("MTCL2001", []):
      push(targetRoute);
      break;
    case Common.getMessage("MTCL2098", []):
      await changeLoginSecurity();
      showConfirmDialog.value = false;
      break;

    default:
      push(targetRoute);
      break;
  }
};
const dialogCancel = () => {
  showConfirmDialog.value = false;
  switch (message.value) {
    case Common.getMessage("MTCL2001", []):
      targetRoute = "";
      break;
    case Common.getMessage("MTCL2098", []):
      break;

    default:
      break;
  }
};
</script>
<style scoped>
.error-group {
  align-items: flex-start;
}

.error-group > label,
.error-group > span {
  margin-top: 0.5em;
}

.input-with-error-area {
  display: flex;
  flex-direction: column;
  margin-left: 0;
}

.input-with-error-area > input,
.input-with-error-area > p {
  margin-left: 10px;
}
</style>
